import { Component, CSSProperties } from "react";
import Checkbox from "@sdkit/checkbox";

type Props = {
  className?: string;
  columns?: any[];
  index?: any;
  style?: CSSProperties;
  onSelectAll: (options: any) => void;
  isSelectable: boolean;
  isSelectedAll: boolean;
};

export class HeaderRowRenderer extends Component<Props> {
  handleSelect = e => {
    const { onSelectAll } = this.props;
    const isSelectedAll = e.target.checked;

    onSelectAll(isSelectedAll);
  };

  render() {
    const { handleSelect } = this;
    const {
      className,
      columns,
      index,
      style,
      isSelectable,
      isSelectedAll
    } = this.props;

    return (
      <div role="row" key={index} style={style} className={className}>
        {isSelectable && (
          <div
            className="ReactVirtualized__Table__rowColumn"
            style={{ flexShrink: 0 }}
          >
            <Checkbox checked={isSelectedAll} onChange={handleSelect} />
          </div>
        )}

        {columns}
      </div>
    );
  }
}
